export default "__VITE_ASSET__1799434f__"